import React from 'react';
import { ContextModel } from './context-model';
import { configuration } from '../../../../hooks/useMockConfiguration';

export class ContextService {
	public json: ContextModel;
	changeLanguageVariant: (a: string) => void = () => null;
	pagesWithAdditionalContext: string[] = [];
	mock?: configuration;

	constructor(
		contextJson?: any,
		translation?: { [key: string]: string },
		changePerformer?: (a: string) => void,
		additionalTranslations?: { [key: string]: string }
	) {
		if (translation) {
			const params: { [key: string]: string } = contextJson.params;
			const jsonCopy = JSON.parse(JSON.stringify(contextJson));
			const translated = this.translateKeys(
				jsonCopy,
				translation,
				params,
				['id', 'params', 'languages', 'value'],
				additionalTranslations
			);
			this.json = new ContextModel(translated);
		} else {
			this.json = new ContextModel(contextJson);
		}
		if (changePerformer) {
			this.changeLanguageVariant = changePerformer;
		}
	}

	private translate(
		translation: { [key: string]: string },
		value: string,
		params: { [key: string]: string },
		additionalParams?: { [key: string]: string }
	): string {
		let translated = '';
		if (additionalParams) {
			translated = additionalParams[value];
		}
		if (translated === undefined || translated === '') {
			translated = translation[value];
		}
		if (translated !== undefined) {
			const regexp = /\{params\.[a-zA-Z]*\}/;
			let match = regexp.exec(translated);
			while (match) {
				const paramKeyStartPosition = translated.indexOf('.', match.index);
				const paramKeyEndPosition = translated.indexOf('}', match.index);
				translated = translated.replace(
					regexp,
					params[
						translated.substring(paramKeyStartPosition + 1, paramKeyEndPosition)
					]
				);
				match = regexp.exec(translated);
			}
			return translated;
		}
		return value;
	}

	private translateArray(
		value: any,
		translation: { [key: string]: string },
		params: { [key: string]: string },
		ignoreFields: string[],
		additionalTranslations?: { [key: string]: string }
	) {
		for (let i = 0; i < value.length; ++i) {
			if (typeof value[i] !== 'string') {
				this.translateKeys(
					value[i],
					translation,
					params,
					ignoreFields,
					additionalTranslations
				);
			} else {
				value[i] = this.translate(
					translation,
					value[i],
					params,
					additionalTranslations
				);
			}
		}
	}
	private translateIfNotIgnored(
		ignoreFields: string[],
		value: any,
		key: string,
		contextJson: any,
		translation: { [key: string]: string },
		params: { [key: string]: string },
		additionalTranslations?: { [key: string]: string }
	) {
		if (ignoreFields.indexOf(key) === -1) {
			if (typeof value === 'string') {
				contextJson[key] = this.translate(
					translation,
					value,
					params,
					additionalTranslations
				);
			} else {
				if (value.length !== undefined) {
					this.translateArray(
						value,
						translation,
						params,
						ignoreFields,
						additionalTranslations
					);
				} else {
					this.translateKeys(
						contextJson[key],
						translation,
						params,
						ignoreFields,
						additionalTranslations
					);
				}
			}
		}
	}

	private translateKeys(
		contextJson: ContextModel,
		translation: { [key: string]: string },
		params: { [key: string]: string },
		ignoreFields: string[],
		additionalTranslations?: { [key: string]: string }
	) {
		for (const [key, value] of Object.entries(contextJson)) {
			if (value) {
				this.translateIfNotIgnored(
					ignoreFields,
					value,
					key,
					contextJson,
					translation,
					params,
					additionalTranslations
				);
			}
		}
		return contextJson;
	}
}

const context = React.createContext<ContextService>(new ContextService());
export const ContextProvider = context.Provider;
export default context;
